/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_DatabasesInputs */

const en_page_title_databases = /** @type {(inputs: Page_Title_DatabasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Databases`)
};

const nl_page_title_databases = /** @type {(inputs: Page_Title_DatabasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Databases`)
};

/**
* | output |
* | --- |
* | "Databases" |
*
* @param {Page_Title_DatabasesInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const page_title_databases = /** @type {((inputs?: Page_Title_DatabasesInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_DatabasesInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_page_title_databases(inputs)
	return en_page_title_databases(inputs)
});